<template>
  <div class="create-role">
    <RoleForm mode="create" />
  </div>
</template>
<script>
export default {
  components: {
    RoleForm: () => import(/* webpackChunkName: "RoleForm" */ '@/views/User/RoleForm')
  }
}
</script>
